import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import outputLogoStripes from "assets/images/output-logo-180x180.svg";
import { useTranslation } from "react-i18next";

interface MessageWithLogoProps {
  children: string;
}

function MessageWithLogo(props: MessageWithLogoProps) {
  const { t } = useTranslation();
  return (
    <Box sx={{ pt: 4, textAlign: "center" }}>
      <Typography variant="h2">{props.children}</Typography>
      <Box sx={{ pt: 2 }}>
        <img src={outputLogoStripes} alt={t("global.logo_stripes_alt_text")} />
      </Box>
    </Box>
  );
}

export default MessageWithLogo;
